<router-outlet (activate)="isLoaderVisible = false" />

@if (isLoaderVisible) {
  <div class="loader-container">
    <img src="/assets/images/logos/cx-manager-cinetixx.svg" alt="cinetixx" />
    <div class="loader">
      <div class="loader-bar"></div>
    </div>
  </div>
}

<app-cookies
  colorBrand="#0d6ebc"
  link1Href="/de/page/impressum"
  link2Href="/de/page/datenschutz"
  link1Text="Impressum"
  link2Text="Datenschutzerklärung"
  moreInformationLinkHref="/de/page/datenschutz"
/>

@if (isNewVersionModalVisible) {
  <cx-new-version-modal #newVersionModalComponent />
}
